
import Logger from '../../../../Utils/Logger';
import EDLink from '../../../../BaseComponents/Link/EDLink';

import { makeStyles } from 'tss-react/mui';

interface IProps {}

const useStyles = makeStyles()(theme => ({
  link: {
    '&&': {
      color: theme.palette.common.white,
      '&:hover': {
        borderColor: theme.palette.common.white,
      },
    },
  },
}));

const versionStringToMajorMinorVersionString = (version: string) => {
  return version.split('.').slice(0, 2).join('.');
};

const VersionLink: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();

  const isGas = false; // TODO: GAS har en egen changelog där bara delsystem som ingår i gas är med
  const changelogArchiveUrl = 'https://www.avenydata.se/AvenyChangeLogs';

  // FIXME: konsollen säger att den inte kan läsa versionsnumret.
  const version = config.version;

  if (version) {
    const changelogUrl = `${changelogArchiveUrl}/${
      isGas ? 'GAS_' : ''
    }Aveny_uppdatering_${versionStringToMajorMinorVersionString(
      version
    )}.html?utm_source=Nya_Aveny&utm_medium=Aveny`;
    return (
      <EDLink
        href={changelogUrl}
        className={classes.link}
        target="_blank"
        testId="versionLink"
      >
        Version {version}
      </EDLink>
    );
  } else {
    Logger.error('Kunde inte läsa versionssiffran');
    return null;
  }
};

export default VersionLink;
